/* Veda Harvest – product page helpers: sub-nav highlight, spec labels */
(() => {
  const nav = document.querySelector('[data-vc-subnav]');
  if (nav) {
    const strip = nav.querySelector('.vc-info__navin');
    let links = [...nav.querySelectorAll('a[href^="#"]')];
    links.forEach((a) => { if (!document.querySelector(a.getAttribute('href'))) a.remove(); });
    links = [...nav.querySelectorAll('a[href^="#"]')];
    const targets = links.map((a) => document.querySelector(a.getAttribute('href'))).filter(Boolean);
    if ('IntersectionObserver' in window && targets.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const id = '#' + en.target.id;
          links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === id));
          const act = nav.querySelector('.is-active');
          if (act && strip) strip.scrollTo({ left: Math.max(0, act.offsetLeft - 24), behavior: 'smooth' });
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      targets.forEach((t) => io.observe(t));
    }
  }
  /* "Label: value" lines in product details become two-column rows */
  document.querySelectorAll('[data-vc-spec] li').forEach((li) => {
    const t = li.textContent; const i = t.indexOf(':');
    if (i > 0 && i < 40) {
      li.innerHTML = '';
      const b = document.createElement('b'); b.textContent = t.slice(0, i).trim();
      const s = document.createElement('span'); s.textContent = t.slice(i + 1).trim();
      li.append(b, s);
    }
  });
})();
